import React from 'react';
export function Footer() {
  return <footer className="bg-cream py-8 border-t border-silver-light text-center px-4" data-id="element-123" data-mp="32wd2qgad7ltj">
      <div className="max-w-4xl mx-auto" data-id="element-124" data-mp="3gg0zo4mhnzy6">
        <p className="text-graphite-light text-sm" data-id="element-125" data-mp="32nukakr5twzs">
          © 2026 Ninja Coach Ready — All rights reserved.
        </p>
      </div>
    </footer>;
}